import React from "react";

const MAP = {
  "Submitted": "badge-Submitted",
  "Pending CH Approval": "badge-PendingCH",
  "Pending Admin Approval": "badge-PendingAdmin",
  "Approved": "badge-Approved",
  "Partially Approved": "badge-PartiallyApproved",
  "Rejected": "badge-Rejected",
  "Ready for Issue": "badge-ReadyForIssue",
  "Issued": "badge-Issued",
  "Pending Engineer Usage Update": "badge-PendingUsage",
  "Used": "badge-Used",
  "Closed": "badge-Closed",
  "Cancelled": "badge-Cancelled",
  "Faulty": "badge-Faulty",
  "Repair": "badge-Repair",
  "Scrap": "badge-Scrap",
  "In Transit Recovery": "badge-InTransit",
  "In Transit": "badge-InTransit",
  "Delivered": "badge-Delivered",
  "Created": "badge-Created",
  "Packed": "badge-Packed",
  "Dispatched": "badge-Dispatched",
  "Received": "badge-Received",
  "Working": "badge-Approved",
  "Damaged": "badge-Faulty",
  "Repairable": "badge-Repair",
};

export default function StatusBadge({ status, className = "", ...rest }) {
  const cls = MAP[status] || "badge-Closed";
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold ${cls} ${className}`}
      data-testid={`status-badge-${(status || "").replace(/\s+/g, "-").toLowerCase()}`}
      {...rest}
    >
      {status || "—"}
    </span>
  );
}
